import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import regenHighlight from "../../assets/regenHighlight.jpg";
import regen2 from "../../assets/regen2.jpg";
import regen3 from "../../assets/regen3.jpg";
import regen4 from "../../assets/regen4.jpg";
import regen5 from "../../assets/regen5.jpg";
// Kindred Dating Platform Screenshots
import desktopLanding from "../../assets/desktoplanding.png";
import landing1 from "../../assets/landing1.png";
import editProfileiphone from "../../assets/editProfileiphone.png";
import inviteValidator from "../../assets/inviteValidator.png";
import profileIpad from "../../assets/profile-ipad.png";
import matchPageIphone from "../../assets/matchPageIphone.png";
import settingIphone from "../../assets/settingsIphone.png";

// JC Eats Restaurant Platform Screenshots
import jcLanding1 from "../../assets/jc-landing1.png";
import jcLanding2 from "../../assets/jc-landing2.png";
import jcLanding3 from "../../assets/jc-landing3.png";
import jcCategories1 from "../../assets/jc-categories1.png";
import jcCategories2 from "../../assets/jc-categories2.png";
import jcSearch1 from "../../assets/jc-serach1.png";
import jcSearchModal from "../../assets/jc-search-modal-pop-up.png";
import jcFavorites1 from "../../assets/jc-favorites1.png";
import jcFavoritesPopup from "../../assets/jc-favorites-pop-up.png";

import "./Projects.css";

const regenImages = [
  {
    src: regenHighlight,
    alt: "Regen Rewards Main Dashboard",
    title: "Main Dashboard",
  },
  { src: regen4, alt: "Landing Page Experience", title: "Landing Page" },
  { src: regen3, alt: "Receipt Scanning Feature", title: "Receipt Scanner" },
  { src: regen2, alt: "Points Banking System", title: "Points Bank" },
  { src: regen5, alt: "Flash Sales Interface", title: "Flash Sales" },
];

const kindredImages = [
  {
    src: desktopLanding,
    alt: "Kindred Desktop Landing Page - Fresh Approach to Matchmaking",
    title: "Desktop Landing Experience",
  },
  {
    src: landing1,
    alt: "Kindred Mobile Login Interface",
    title: "Mobile Login",
  },
  {
    src: editProfileiphone,
    alt: "Profile Editing Interface on iPhone",
    title: "Profile Management",
  },
  {
    src: inviteValidator,
    alt: "Validator Invitation System",
    title: "Invite Validators",
  },
  {
    src: profileIpad,
    alt: "User Profile View on iPad",
    title: "Profile Display",
  },
  {
    src: matchPageIphone,
    alt: "Advanced Matching Interface on iPhone",
    title: "Smart Matching",
  },
  {
    src: settingIphone,
    alt: "Settings and Preferences on iPhone",
    title: "Settings & Privacy",
  },
];

const jcEatsImages = [
  {
    src: jcLanding1,
    alt: "JC Eats Homepage with Restaurant Discovery Features",
    title: "Homepage Overview",
  },
  {
    src: jcLanding2,
    alt: "Featured Restaurants and Quick Categories",
    title: "Restaurant Features",
  },
  {
    src: jcLanding3,
    alt: "Homepage Statistics and Call-to-Action",
    title: "Platform Stats",
  },
  {
    src: jcCategories1,
    alt: "Browse Restaurants by Cuisine Categories",
    title: "Cuisine Categories",
  },
  {
    src: jcCategories2,
    alt: "Detailed Category View with Restaurant Counts",
    title: "Category Details",
  },
  {
    src: jcSearch1,
    alt: "Advanced Search Interface with Filters",
    title: "Search & Filter",
  },
  {
    src: jcSearchModal,
    alt: "Search Modal with Real-time Results",
    title: "Search Modal",
  },
  {
    src: jcFavorites1,
    alt: "Personal Favorites Management System",
    title: "Favorites System",
  },
  {
    src: jcFavoritesPopup,
    alt: "Favorites Export and Import Features",
    title: "Data Management",
  },
];

const projects = [
  {
    id: 1,
    name: "Kindred Dating Platform",
    subtitle:
      "A Fresh Approach to Matchmaking - Meet people exclusively through mutual connections. Invite your community to participate.",
    description:
      "Kindred is an innovative online matchmaking platform that leverages social networks to foster authentic connections. Built to address the shortcomings of traditional dating apps, Kindred creates an environment of transparency, honesty, and accountability—all rooted in your community. The platform features a unique dual-role system where Daters find matches while Validators (friends/family) provide recommendations and validation.",
    images: kindredImages,
    stats: [
      { number: "2x", label: "Match Quality" },
      { number: "15+", label: "Core Features" },
      { number: "100%", label: "Full-Stack" },
    ],
    techStack: [
      "React.js",
      "Node.js",
      "MongoDB",
      "Express.js",
      "AWS (EC2, S3, RDS)",
      "Azure DevOps",
      "Cloudinary",
      "SendGrid",
      "JWT Authentication",
      "OAuth Integration",
      "Geospatial Indexing",
      "Redis Caching",
      "RESTful APIs",
      "CI/CD Pipeline",
    ],
    keyFeatures: [
      "🤝 Multi-Role System (Daters & Validators)",
      "🗺️ Advanced Geospatial Matching",
      "🔍 Friends-of-Friends Social Graph",
      "🛡️ Multi-Layer Verification (Email + AWS Face Recognition + Social)",
      "⚡ Real-time Trust & Safety Model",
    ],
    achievements: [
      "Owned full product lifecycle from concept to deployment, launching a modern dating platform",
      "Architected scalable multi-role system (Daters & Validators) with robust MongoDB schemas and relationship models",
      "Engineered advanced matchmaking algorithms with geospatial compatibility (2dsphere indexes) and validator influence scoring",
      "Implemented performance-focused indexing strategies (compound, geospatial, text, TTL) and Redis caching layers",
      "Built multi-level registration with real-time verification (email, OAuth, live photo capture) establishing unique trust model",
      "Delivered visually engaging, accessible UI/UX using Figma and modern design principles driving early user engagement",
      "Collaborated with leadership aligning technical execution with business goals ensuring successful product launch",
    ],
    liveLink: "https://kindreddate.com", // Replace with actual URL
    isLive: true,
  },
  {
    id: 2,
    name: "Regen Rewards",
    subtitle:
      "Regen Rewards gives wellness and sustainability-minded consumers cash savings on regenerative organic certified food products.",
    description:
      "Regen Rewards gives wellness and sustainability-minded consumers cash savings on regenerative organic certified food products. By scanning receipts, consumers receive rebates that convert to cashback directly into bank accounts. The rewards gamification lowers costs of expensive products and incentivizes consumers to favor regen products over conventional ones. Regenerative organic brands can increase visibility, host flash sales, and participate in campaigns - all within the app, creating a market-based catalyst to transform global food systems and reverse climate change.",
    images: regenImages,
    stats: [
      { number: "30%", label: "Performance Boost" },
      { number: "5", label: "Core Features" },
      { number: "100%", label: "Full-Stack" },
    ],
    techStack: [
      "React Native",
      "Node.js",
      "MongoDB",
      "Express.js",
      "AWS (EC2, S3, RDS)",
      "Azure DevOps",
      "Cloudinary",
      "SendGrid",
      "JWT Authentication",
      "Google OAuth",
      "Redis Caching",
      "RESTful APIs",
      "CI/CD Pipeline",
    ],
    keyFeatures: [
      "🌱 Gamified Sustainability Tracking",
      "📱 Cross-platform Mobile Experience",
      "🔐 Secure Authentication System",
      "⚡ 30% Performance Optimization",
      "💰 Dynamic Rewards System",
    ],
    achievements: [
      "Led end-to-end development of full-stack sustainability app with Node.js and MongoDB backend architecture",
      "Developed and deployed React Native frontend with Google OAuth integration enhancing user engagement",
      "Reduced API call latency by 30% through effective asynchronous programming and RESTful API design",
      "Implemented JWT-based authentication following OWASP best practices ensuring data integrity and security",
      "Built real-time tracking system for eco-friendly activities supporting sustainable farming initiatives",
      "Integrated comprehensive receipt scanning and validation system with dynamic rewards processing",
    ],
    liveLink: null,
    isLive: false,
  },
  {
    id: 3,
    name: "JC Eats - Restaurant Finder",
    subtitle:
      "A comprehensive restaurant discovery platform featuring 167+ carefully curated establishments across Jersey City and NYC with zero external API dependencies.",
    description:
      "JC Eats is a comprehensive restaurant discovery platform showcasing 167+ hand-picked establishments across Jersey City, Manhattan, Brooklyn, Queens, and Hoboken. Built entirely with vanilla JavaScript and a rich local dataset, the platform requires no external APIs or internet connection while delivering advanced search capabilities, smart filtering, and a sophisticated favorites system. Originally started as 'Boston Eat' but evolved into a Jersey City-focused platform serving the diverse NYC metropolitan dining scene.",
    images: jcEatsImages,
    stats: [
      { number: "167+", label: "Curated Restaurants" },
      { number: "20+", label: "Cuisine Types" },
      { number: "100%", label: "Offline Ready" },
    ],
    techStack: [
      "Vanilla JavaScript ES6+",
      "HTML5 Semantic Markup",
      "CSS3 Grid & Flexbox",
      "Local JSON Database",
      "LocalStorage API",
      "SessionStorage API",
      "Font Awesome Icons",
      "Google Fonts",
      "Lazy Loading",
      "Responsive Design",
      "Progressive Enhancement",
      "Accessibility (WCAG)",
      "Performance Optimization",
    ],
    keyFeatures: [
      "🍽️ 167+ Hand-Curated Restaurants",
      "🚫 Zero External API Dependencies",
      "🔍 Advanced Multi-Filter Search",
      "❤️ Smart Favorites System",
      "📱 100% Responsive Design",
      "🏙️ 5 Major NYC Areas Coverage",
      "🎯 20+ Diverse Cuisine Types",
      "📊 Real-time Search Results",
      "💾 Full Offline Functionality",
      "⚡ Optimized Performance",
    ],
    achievements: [
      "Architected comprehensive restaurant discovery platform serving 167+ curated establishments across NYC metro area",
      "Engineered zero-dependency local database system eliminating external API costs and ensuring 100% offline functionality",
      "Designed advanced multi-criteria search with real-time filtering by cuisine, location, price, rating, and venue type",
      "Implemented intelligent image loading system with automatic fallbacks and lazy loading for optimal performance",
      "Built sophisticated favorites management with LocalStorage persistence, export/import, and visit tracking capabilities",
      "Developed responsive mobile-first design ensuring seamless experience across all devices and screen sizes",
      "Optimized performance through debounced search, intelligent caching, and modular JavaScript architecture",
    ],
    liveLink: "https://jc-eats.netlify.app/",
    isLive: true,
  },
];

export default function Projects() {
  const navigate = useNavigate();
  const [currentProject, setCurrentProject] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);

  const activeProject = projects[currentProject];
  const projectImages = activeProject.images;
  const [selectedImage, setSelectedImage] = useState(projectImages[0].src);

  const openModal = (image) => {
    setModalImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage(null);
  };

  // Update selected image when project changes
  useEffect(() => {
    setSelectedImage(projectImages[0].src);
  }, [currentProject, projectImages]);

  const navigateModal = useCallback(
    (direction) => {
      if (!modalImage) return;

      const currentIndex = projectImages.findIndex(
        (img) => img.src === modalImage.src,
      );
      let newIndex;

      if (direction === "next") {
        newIndex =
          currentIndex === projectImages.length - 1 ? 0 : currentIndex + 1;
      } else {
        newIndex =
          currentIndex === 0 ? projectImages.length - 1 : currentIndex - 1;
      }

      setModalImage(projectImages[newIndex]);
      setSelectedImage(projectImages[newIndex].src); // Update main display too
    },
    [modalImage, setSelectedImage, projectImages],
  );

  // Keyboard navigation support
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (!isModalOpen) return;

      if (e.key === "ArrowLeft") {
        navigateModal("prev");
      } else if (e.key === "ArrowRight") {
        navigateModal("next");
      } else if (e.key === "Escape") {
        closeModal();
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [isModalOpen, modalImage, navigateModal]);

  return (
    <section className="projects-showcase">
      {/* Project Navigation */}
      <div className="project-navigation">
        <div className="nav-container">
          <h2 className="projects-title">
            Featured <span className="highlight-text-project">Projects</span>
          </h2>
          <div className="project-tabs">
            {projects.map((project, index) => (
              <button
                key={project.id}
                className={`project-tab ${
                  index === currentProject ? "active" : ""
                }`}
                onClick={() => {
                  setCurrentProject(index);
                  setSelectedImage(project.images[0].src);
                }}
              >
                {project.name}
                {project.isLive && <span className="live-indicator">LIVE</span>}
              </button>
            ))}
          </div>
        </div>
      </div>
      {/* Hero Section */}
      <div className="hero-badge">Featured Project</div>
      <div className="project-hero">
        <div className="hero-content">
          <div className="title-subtitle-container">
            <h1 className="project-title">
              <span className="highlight-text-project">
                {activeProject.name}
              </span>
            </h1>
            <div className="vertical-divider"></div>
            <p className="project-subtitle">{activeProject.subtitle}</p>
          </div>
        </div>

        <div className="hero-stats">
          {activeProject.stats.map((stat, index) => (
            <div key={index} className="stat-item">
              <span className="stat-number">{stat.number}</span>
              <span className="stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Interactive Image Gallery */}
      <div className="gallery-section">
        <div className="main-display">
          <div className="image-container">
            <img
              src={selectedImage}
              alt="Project showcase"
              className="featured-image"
              onClick={() =>
                openModal(
                  projectImages.find((img) => img.src === selectedImage),
                )
              }
            />
            <div className="image-overlay">
              <div className="overlay-content">
                <h3>
                  {
                    projectImages.find((img) => img.src === selectedImage)
                      ?.title
                  }
                </h3>
                <p className="click-hint">Click to view full size</p>
              </div>
            </div>
          </div>
        </div>

        <div className="thumbnail-grid">
          {projectImages.map((image, index) => (
            <div key={index} className="thumbnail-wrapper">
              <div
                className={`thumbnail ${
                  selectedImage === image.src ? "active" : ""
                }`}
                onClick={() => setSelectedImage(image.src)}
              >
                <img src={image.src} alt={image.alt} />
                <div className="thumbnail-overlay">
                  <span>{image.title}</span>
                </div>
              </div>
              <button
                className="fullscreen-btn"
                onClick={() => openModal(image)}
                title="View full size"
              >
                🔍
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Project Details Grid */}
      <div className="details-grid">
        {/* Overview Card */}
        <div className="detail-card overview-card">
          <div className="card-header">
            <h3>Project Overview</h3>
            <div className="card-icon">💡</div>
          </div>
          <div className="card-content">
            <p>{activeProject.description}</p>
            <div className="impact-metrics">
              <div className="metric">
                <span className="metric-value">Real-time</span>
                <span className="metric-desc">Action Tracking</span>
              </div>
              <div className="metric">
                <span className="metric-value">Gamified</span>
                <span className="metric-desc">User Experience</span>
              </div>
            </div>
          </div>
        </div>

        {/* Tech Stack Card */}
        <div className="detail-card tech-card">
          <div className="card-header">
            <h3>Technology Stack</h3>
            <div className="card-icon">⚡</div>
          </div>
          <div className="card-content">
            <div className="tech-grid">
              {activeProject.techStack.map((tech, index) => (
                <div key={index} className="tech-item">
                  <span className="tech-dot"></span>
                  {tech}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Features Card */}
        <div className="detail-card features-card">
          <div className="card-header">
            <h3>Key Features</h3>
            <div className="card-icon">🚀</div>
          </div>
          <div className="card-content">
            <div className="features-list">
              {activeProject.keyFeatures.map((feature, index) => (
                <div key={index} className="feature-item">
                  {feature}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Development Highlights */}
        <div className="detail-card highlights-card">
          <div className="card-header">
            <h3>Development Highlights</h3>
            <div className="card-icon">🏆</div>
          </div>
          <div className="card-content">
            {activeProject.achievements.map((achievement, index) => (
              <div key={index} className="highlight-item">
                <div className="achievement-bullet">🎯</div>
                <p>{achievement}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="cta-section">
        <div className="cta-content">
          <h2>Interested in the Details?</h2>
          <p>
            The projects featured here are real client work, which means the
            codebases remain private. If you're interested, I'd be happy to
            discuss the architecture, technologies, challenges, and decisions
            that went into building them.
          </p>

          <div className="cta-buttons">
            <button
              className="btn btn-primary"
              onClick={() => navigate("/contact")}
            >
              <span className="btn-text">Request Code Review</span>
              <span className="btn-icon">→</span>
            </button>
            <button
              className="btn btn-secondary"
              onClick={() =>
                activeProject.liveLink &&
                window.open(activeProject.liveLink, "_blank")
              }
              disabled={!activeProject.liveLink}
            >
              <span className="btn-text">
                {activeProject.liveLink ? "View Live Demo" : "Coming Soon"}
              </span>
              <span className="btn-icon">
                {activeProject.liveLink ? "🚀" : "⏳"}
              </span>
            </button>
          </div>

          <div className="availability-note">
            <span className="status-indicator"></span>
            Available for detailed discussion and code walkthrough
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {isModalOpen && modalImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              ×
            </button>

            {/* Navigation Buttons */}
            <button
              className="modal-nav modal-prev"
              onClick={() => navigateModal("prev")}
              title="Previous image"
            >
              ←
            </button>
            <button
              className="modal-nav modal-next"
              onClick={() => navigateModal("next")}
              title="Next image"
            >
              →
            </button>

            <img
              src={modalImage.src}
              alt={modalImage.alt}
              className="modal-image"
            />

            <div className="modal-info">
              <h3>{modalImage.title}</h3>
              <p>{modalImage.alt}</p>
              <div className="modal-counter">
                {projectImages.findIndex((img) => img.src === modalImage.src) +
                  1}{" "}
                of {projectImages.length}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
